export default __webpack_public_path__ + "static/footer-bottom-image-6cf3f35bf052e78772dcee18292b1d81.webp";